module.exports = __webpack_public_path__ + "img/blue_150.d507cd9d.png";